import {
  FlashcardNodeData,
  MediaData,
  FlashcardMediaData,
  FlashcardData,
} from '../../../types/quiz';
import { getQuestion, parseMainExp } from './utils';

/**
 * FlashcardData.
 */
export const mapFlashcardData = ({
  data,
  mediaData,
}: {
  data: FlashcardNodeData;
  mediaData: MediaData<FlashcardMediaData[]>;
}): FlashcardData => {
  return {
    front: getQuestion<FlashcardMediaData[]>(data.q, mediaData),
    mainExplanation:
      parseMainExp<FlashcardMediaData[]>(data.e, mediaData) || '',
    flashcardType: data.z,
  };
};
